import React, { useState } from "react";
import "./About.css";

function About() {
  const [flip, setFlip] = useState(false);

  function flipImage() {
    setFlip((preValue) => !preValue);
  }

  return (
    <div className="components" id="about-div">
      <img
        src={require(`../../media/${flip ? "ishaan" : "bitmoji"}.png`).default}
        alt="profile"
        id="profile-picture"
        onClick={flipImage}
        onContextMenu={(e) => e.preventDefault()} //disable right click
      />
      <p className="p" id="about">
        I'm Ishaan, a Software Engineering with +1 year of experience.
      </p>
      <p className="p" id="about">
        I am a hardworking and ever always enthusiastic person who loves getting
        newer and unexplored opportunities to work and widen my reach.
      </p>
      <p className="p" id="about">
        I think I've always been a coder at heart - having the chance to learn
        and develop myself is what motivates me more than anything else, and I
        love being able to combine my creative side with my problem solving
        skills. Solving new problems is a passion that has helped me develop a
        wide spectrum of skills and continuous search for more.
      </p>
    </div>
  );
}

export default About;
